const Center = require('./Center');
const Child = require('./Child');
const Parent = require('./Parent');

class TourRequest {
  constructor() {
    this.init();
  }

  init() {
    this.request_id = undefined;
    this.center = undefined;
    this.parent = undefined;
    this.child = undefined;
    this.request_date = undefined;
    this.requested_times = undefined;
    this.preferred_date = undefined;
    this.notes = undefined;
  }

  copy() {
    const cp = new Tour();

    cp.request_id = this.request_id;
    cp.request_date = this.request_date ? new Date(this.request_date) : undefined;
    cp.requested_times = this.requested_times ? Object.assign({}, this.requested_times) : undefined;
    cp.preferred_date = this.preferred_date ? new Date(this.preferred_date) : undefined;
    cp.notes = this.notes;
    
    if (this.center) {
      cp.center = this.center.copy();
    }
    if (this.child) {
      cp.child = this.child.copy();
    }
    if (this.parent) {
      cp.parent = this.parent.copy();
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.request_id = obj.request_id ? obj.request_id.toString() : undefined;
      this.request_date = obj.request_date ? new Date(obj.request_date) : undefined;
      this.requested_times = obj.requested_times ? Object.assign({}, obj.requested_times) : undefined;
      this.preferred_date = obj.preferred_date ? new Date(obj.preferred_date) : undefined;
      this.notes = obj.notes ? obj.notes : undefined;

      if (obj.center) {
        this.center = new Center();
        this.center.buildFromJSON(obj.center);
      }
      if (obj.child) {
        this.child = new Child();
        this.child.buildFromJSON(obj.child);
      }
      if (obj.parent) {
        this.parent = new Parent();
        this.parent.buildFromJSON(obj.parent);
      }
    }
  }

  toString() {
    let result = this.request_id ? this.request_id : '';
    return result;
  }

  getId() {
    return this.request_id;
  }

  setId(request_id) {
    this.request_id = request_id ? request_id.toString() : undefined;
  }

  getCenter() {
    return this.center;
  }

  setCenter(center) {
    this.center = center ? center.copy() : undefined;
  }

  getRequestDate() {
    return this.request_date;
  }

  setRequestDate(request_date) {
    this.request_date = request_date ? new Date(request_date) : undefined;
  }

  getRequestedTimes() {
    return this.requested_times;
  }

  setRequestedTimes(requested_times) {
    this.requested_times = requested_times ? Object.assign({}, requested_times) : undefined;
  }

  getPreferredDate() {
    return this.preferred_date;
  }

  setPreferredDate(preferred_date) {
    this.preferred_date = preferred_date ? new Date(preferred_date) : undefined;
  }

  getNotes() {
    return this.notes;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  getParent() {
    return this.parent;
  }

  setParent(parent) {
    this.parent = (parent) ? parent.copy() : undefined;
  }

  getChild() {
    return this.child;
  }

  setChild(child) {
    this.child = (child) ? child.copy() : undefined;
  }
}

module.exports = TourRequest;
